import {Component, Input, Renderer2, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from 'src/environments/environment';
import {RxAuthService} from 'src/app/services/rx-auth/rx-auth.service';
import {RetailerProfileComponent} from 'src/app/profiles/retailer-profile/retailer-profile.component';
import {ListProfileComponent} from 'src/app/profiles/list-profile/list-profile.component';
import {ChartsCommonFunctions} from '../chartsCommonFunctions';
import {ActivatedRoute} from '@angular/router';
import * as Plotly from 'plotly.js-dist-min'
import {ElementRef} from '@angular/core';
import {ChartHeaderComponent} from '../chart-header/chart-header.component';
import {ChartWrapperComponent} from '../chart-wrapper/chart-wrapper.component';
import {Subscription} from "rxjs";

@Component({
  selector: 'app-heatmap',
  templateUrl: './heatmap.component.html',
  styleUrls: ['./heatmap.component.scss'],
  standalone: true,
  imports: [
    ChartHeaderComponent
  ]
})
export class HeatmapComponent {

  constructor(private http: HttpClient,
              private auth: RxAuthService,
              private retailerprofile: RetailerProfileComponent,
              private listprofile: ListProfileComponent,
              private common: ChartsCommonFunctions,
              private route: ActivatedRoute,
              private elementRef: ElementRef,
              private renderer: Renderer2,
              private chartWrapper: ChartWrapperComponent,
  ) {
  }


  hoverText: string = '';
  @Input() rcl: number | null = null;
  @Input() model: any = '';
  @Input() chartId: string = '';
  @Input() retailer: any = null;
  @Input() isEditMode:boolean = false;

  @ViewChild('chartContainer', {static: true}) chartContainer!: ElementRef;
  showchart: boolean = false;
  profile: any = '';
  current_list: any = '';
  hasThumbnail: boolean = false;
  plotlyChart: any = null
  originalChart: any = null
  text_elements: any = ''
  isMobile: boolean = window.innerWidth < 768;
  plotId: string = '';

  chartData: any = {
    data: [
      {
        z: [
          /*
        [0, 20, 30, 40], // Access
        [15, 25, 35, 45], // Volume
        [20, 30, 40, 50], // Margin
        [25, 35, 45, 55], // Conserve
        [30, 40, 50, 60], // Share
        [35, 45, 55, 65], // Choice
        [40, 50, 60, 70], // Conformance
        [45, 55, 65, 75], // Change
        [50, 60, 70, 80], // Capital */
        ],
        x: ['Capital', 'Operations', 'Product', 'Customer'],
        y: ['Capital',
          'Change',
          'Conformance',
          'Choice',
          'Share',
          'Conserve',
          'Margin',
          'Volume',
          'Access'],
        type: 'heatmap',

        hovertemplate: //Template for the hover text.
          '<b>%{x}:</b><br>' +
          '%{text[0]} <br><br>' +
          '<b>%{y}:</b><br>' +
          '%{text[1]}' +
          '<extra></extra>',
        text: [
          [
            [['Converting all capital into profit or capital growth'], ['Increase in, creation of, returns upon, human,<br>financial, intellectual, social, etc assets']],
            [['Order management and orchestration<br>through the sales cycle'], ['Increase in, creation of, returns upon, human,<br>financial, intellectual, social, etc assets']],
            [['Create, plan, buy, move, sell'], ['Increase in, creation of, returns upon, human,<br>financial, intellectual, social, etc assets']],
            [['Identify, target, acquire, engage, convert,<br>sell, upsell, re-sell, retain, reactivate'], ['Increase in, creation of, returns upon, human,<br>financial, intellectual, social, etc assets']],
          ],
          [
            [['Converting all capital into profit or capital growth'], ['Ability and capacity to flex, change, adapt, instigate,<br>change pace, create, improve, innovate']],
            [['Order management and orchestration<br>through the sales cycle'], ['Ability and capacity to flex, change, adapt, instigate,<br>change pace, create, improve, innovate']],
            [['Create, plan, buy, move, sell'], ['Ability and capacity to flex, change, adapt, instigate,<br>change pace, create, improve, innovate']],
            [['Identify, target, acquire, engage, convert,<br>sell, upsell, re-sell, retain, reactivate'], ['Ability and capacity to flex, change, adapt, instigate,<br>change pace, create, improve, innovate']],
          ],
          [
            [['Converting all capital into profit or capital growth'], ['Time and motion -<br>optimising the process flows and capabilities.<br>The operating and delivery capacity']],
            [['Order management and orchestration<br>through the sales cycle'], ['Time and motion -<br>optimising the process flows and capabilities.<br>The operating and delivery capacity']],
            [['Create, plan, buy, move, sell'], ['Time and motion -<br>optimising the process flows and capabilities.<br>The operating and delivery capacity']],
            [['Identify, target, acquire, engage, convert,<br>sell, upsell, re-sell, retain, reactivate'], ['Time and motion -<br>optimising the process flows and capabilities.<br>The operating and delivery capacity']],
          ],
          [
            [['Converting all capital into profit or capital growth'], ['Maximise against the limiting factor<br>for each successive stage of growth']],
            [['Order management and orchestration<br>through the sales cycle'], ['Maximise against the limiting factor<br>for each successive stage of growth']],
            [['Create, plan, buy, move, sell'], ['Maximise against the limiting factor<br>for each successive stage of growth']],
            [['Identify, target, acquire, engage, convert,<br>sell, upsell, re-sell, retain, reactivate'], ['Maximise against the limiting factor<br>for each successive stage of growth']],
          ],
          [
            [["Converting all capital into profit or capital growth"], ["Increase 'share of the pie': available resources,<br>total spend, total traffic or space"]],
            [["Order management and orchestration<br>through the sales cycle"], ["Increase 'share of the pie': available resources,<br>total spend, total traffic or space"]],
            [["Create, plan, buy, move, sell"], ["Increase 'share of the pie': available resources,<br>total spend, total traffic or space"]],
            [["Identify, target, acquire, engage, convert,<br>sell, upsell, re-sell, retain, reactivate"], ["Increase 'share of the pie': available resources,<br>total spend, total traffic or space"]],
          ],
          [
            [['Converting all capital into profit or capital growth'], ['Reduce waste or zero-benefit activity.<br>Eliminate lost opportunities. Harness by-products']],
            [['Order management and orchestration<br>through the sales cycle'], ['Reduce waste or zero-benefit activity.<br>Eliminate lost opportunities. Harness by-products']],
            [['Create, plan, buy, move, sell'], ['Reduce waste or zero-benefit activity.<br>Eliminate lost opportunities. Harness by-products']],
            [['Identify, target, acquire, engage, convert,<br>sell, upsell, re-sell, retain, reactivate'], ['Reduce waste or zero-benefit activity.<br>Eliminate lost opportunities. Harness by-products']],
          ],
          [
            [['Converting all capital into profit or capital growth'], ['Make more from every activity, contact or capability']],
            [['Order management and orchestration<br>through the sales cycle'], ['Make more from every activity, contact or capability']],
            [['Create, plan, buy, move, sell'], ['Make more from every activity, contact or capability']],
            [['Identify, target, acquire, engage, convert,<br>sell, upsell, re-sell, retain, reactivate'], ['Make more from every activity, contact or capability']],
          ],
          [
            [['Converting all capital into profit or capital growth'], ['More. Throughput, activity, quantity, price']],
            [['Order management and orchestration<br>through the sales cycle'], ['More. Throughput, activity, quantity, price']],
            [['Create, plan, buy, move, sell'], ['More. Throughput, activity, quantity, price']],
            [['Identify, target, acquire, engage, convert,<br>sell, upsell, re-sell, retain, reactivate'], ['More. Throughput, activity, quantity, price']],
          ],
          [
            [['Converting all capital into profit or capital growth'], ['The ability to, and enablers of, trade']],
            [['Order management and orchestration<br>through the sales cycle'], ['The ability to, and enablers of, trade']],
            [['Create, plan, buy, move, sell'], ['The ability to, and enablers of, trade']],
            [['Identify, target, acquire, engage, convert,<br>sell, upsell, re-sell, retain, reactivate'], ['The ability to, and enablers of, trade']],
          ],
        ],
        colorscale: [
          [0, 'white'],
          [1, '#282B59'],
        ],
        showscale: false,
      },
    ],
    layout: {
      margin: {l: 90, t: 30, r: 20, b: 20},
      xaxis: {side: 'top'},
      height: 300,
      hoverlabel: {
        align: 'auto',
        font: {size: 11}
      }
    },
    config: {
      displayModeBar: false,
      staticPlot: this.common.isMobile()
    },
  };

  ngOnInit() {
    this.plotId = `#plot${this.chartId}`
    this.common.isIframe(this.elementRef, this.renderer)
    let currentPath = this.route.snapshot.url[0].path
    if (currentPath === 'shared' || currentPath === 'saved-charts') {
      let url = `${environment.backend_base}main/visualizations/get_public_chart_metadata/`;
      let payload = {rcl: this.rcl};

      this.http.post(url, payload).subscribe((response: any) => {
        this.profile = response.profile;
        this.current_list = response.profile.current_list;
        this.get_heatmap_data(this.rcl);
      });
    } else if (!this.retailer) {
      this.profile = this.listprofile;
      this.current_list = this.profile.listProfile.current_list;
      this.get_heatmap_data(this.rcl);
    } else if (currentPath !== 'shared' && currentPath !== 'saved-charts') {
      this.profile = this.retailerprofile;
      this.current_list = this.profile.retailerProfile.current_list;
      this.get_heatmap_data(this.rcl);
    }
    if (this.isMobile) (
      this.ifIsMobile()
    )
  }

  get_heatmap_data(rcl: number | null) {
    let url = `${environment.backend_base}main/visualizations/get_visualization_data/`;
    let payload = {
      visualization: this.model,
      rcl: rcl,
      component: this.route.component!.name
    };

    let options = this.auth.httpOptions;

    this.http
      .post(url, payload, this.auth.httpOptions)
      .subscribe((response: any) => {
        this.chartData.data[0].z = response.data[0].fields.json.z;
        this.text_elements = this.common.getTextElements(response.text_elements, this.profile)

        this.plotlyChart = this.chartContainer.nativeElement.querySelector(this.plotId)
        this.plotlyChart = Plotly.newPlot(this.plotlyChart, this.chartData.data, this.chartData.layout, this.chartData.config)

        this.common.subscribeToUserEvents(this.plotlyChart, this.chartWrapper)
        this.originalChart = this.common.removeCircularReferences(this.plotlyChart);
        this.showchart = true;
      });
  }

  ifIsMobile() {
    this.chartData.layout.margin = {l: 90, t: 50, r: 20, b: 0}
  }

  resizeChart(width: number, height: number, plotId: any) {
    this.chartId = plotId;
    this.plotId = `#plot${this.chartId}`
    this.plotlyChart = this.elementRef.nativeElement.querySelector(this.plotId)

    Plotly.relayout(this.plotlyChart, {'width': width, 'height': height})

  }

  checkIfThumbnail() {
    return this.hasThumbnail
  }
}
